if (!customElements.get('delyme-gallery')) {
  customElements.define('delyme-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('[data-photo]')];
      this.links = [...this.querySelectorAll('[data-select]')];
      this.dialog = this.querySelector('dialog');
      this.counter = this.querySelector('[data-current]');
      this.index = 0;

      this.select(0, false);
      this.links.forEach((link, index) => {
        link.addEventListener('click', () => this.select(index));
        link.addEventListener('keydown', event => {
          if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const forward = ['ArrowDown', 'ArrowRight'].includes(event.key);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.links.length - 1 :
            (index + (forward ? 1 : -1) + this.links.length) % this.links.length;
          this.select(next);
          this.links[next].focus();
        });
      });

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.select(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.select(this.index + 1));

      let touchX = null;
      this.addEventListener('touchstart', event => { touchX = event.touches[0]?.clientX ?? null; }, { passive: true });
      this.addEventListener('touchend', event => {
        if (touchX === null) return;
        const delta = (event.changedTouches[0]?.clientX ?? touchX) - touchX;
        if (Math.abs(delta) > 45) this.select(this.index + (delta < 0 ? 1 : -1));
        touchX = null;
      }, { passive: true });

      this.slides.forEach(slide => slide.addEventListener('click', event => {
        if (!this.dialog?.showModal) return;
        event.preventDefault();
        const source = slide.querySelector('img');
        let image = this.dialog.querySelector('img');
        if (!image) {
          image = document.createElement('img');
          this.dialog.append(image);
        }
        image.src = slide.href;
        image.alt = source?.alt || '';
        this.dialog.showModal();
      }));

      this.querySelector('[data-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('click', event => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }

    select(index, scroll = true) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.links.forEach((link, i) => {
        const active = i === this.index;
        link.toggleAttribute('aria-current', active);
        link.setAttribute('aria-selected', String(active));
      });
      if (this.counter) this.counter.textContent = String(this.index + 1);
      if (scroll) this.links[this.index]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
  });
}